const shareAggregationValue = ([agg, ...cuAggs], uAggs) => {
  if(!agg) return false
  if(uAggs.findIndex(a => a === agg) !== -1)
    return true

  return shareAggregationValue(cuAggs, uAggs)
}

const hasSameLookupValue = ([key, ...keys], currentUserAggs, userAggs) => {
  if(!key || !currentUserAggs) return false

  if(Array.isArray(currentUserAggs[key])){
    if(shareAggregationValue(currentUserAggs[key], userAggs[key]))
      return true
  }

  return hasSameLookupValue(keys, currentUserAggs, userAggs)
}

export default function ({ input, state, output }) {
  if(!state.get('client.helper.admin.user.isBilles')){
    const lookupKeys = state.get('client.aggregations').reduce((acc, agg) => agg.useAsRegistrationKeyLookup ? [...acc, agg.key] : acc, [])
    if (lookupKeys.length) {
      const currentUserAggs = state.get('client.user.currentClient.aggregations')
      return output({
        result: input.result.reduce((acc, user) => {
          return hasSameLookupValue(lookupKeys, currentUserAggs, user.clients.aggregations) ? [...acc, user] : acc
        }, [])
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/modules/app/actions/filterByKeyLookup.js